(function () {
  if (window.__alchemyFastCartControls) return;
  window.__alchemyFastCartControls = true;

  var pendingChanges = new Map();
  var refreshPromise = null;

  function getNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function updateCartCount(count) {
    var countElement = document.getElementById('CartCount');
    if (countElement && Number.isFinite(count)) {
      countElement.textContent = count;
    }
  }

  function updateButtonStates(wrapper, quantity) {
    var minusButton = wrapper.querySelector('.cart-drawer__quantity-btn-minus');
    var plusButton = wrapper.querySelector('.cart-drawer__quantity-btn-plus');
    var inventoryQuantity = getNumber(wrapper.dataset.inventory, 0);
    var trackQuantity = wrapper.dataset.trackQuantity === 'true';
    var allowOversell = wrapper.dataset.allowOversell === 'true';

    if (minusButton) {
      var disableMinus = quantity <= 1;
      minusButton.disabled = disableMinus;
      minusButton.classList.toggle('disabled', disableMinus);
    }

    if (plusButton) {
      var disablePlus = trackQuantity && !allowOversell && quantity >= inventoryQuantity;
      plusButton.disabled = disablePlus;
      plusButton.classList.toggle('disabled', disablePlus);
    }
  }

  function refreshDrawer(itemCount) {
    if (refreshPromise) return refreshPromise;

    var currentContent = document.getElementById('CartDrawerContent');
    var currentItems = document.getElementById('CartDrawerItems');
    var savedScroll = currentItems ? currentItems.scrollTop : 0;

    refreshPromise = fetch('/cart?view=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart drawer');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshContent = doc.getElementById('CartDrawerContent');

        if (currentContent && freshContent) {
          currentContent.innerHTML = freshContent.innerHTML;

          var refreshedItems = document.getElementById('CartDrawerItems');
          if (refreshedItems) refreshedItems.scrollTop = savedScroll;
        }

        updateCartCount(itemCount);
      })
      .catch(function (error) {
        console.error('Fast cart refresh error:', error);
      })
      .finally(function () {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function scheduleChange(key, quantity) {
    var state = pendingChanges.get(key) || {
      desiredQuantity: quantity,
      inFlight: false,
      timer: null
    };

    state.desiredQuantity = quantity;

    if (state.timer) clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      commitChange(key);
    }, 90);

    pendingChanges.set(key, state);
  }

  function commitChange(key) {
    var state = pendingChanges.get(key);
    if (!state || state.inFlight) return;

    state.inFlight = true;
    state.timer = null;

    var sentQuantity = state.desiredQuantity;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: sentQuantity
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to update cart quantity');
        return response.json();
      })
      .then(function (cart) {
        state.inFlight = false;
        updateCartCount(cart.item_count);

        if (state.desiredQuantity !== sentQuantity) {
          commitChange(key);
          return;
        }

        pendingChanges.delete(key);
        refreshDrawer(cart.item_count);
      })
      .catch(function (error) {
        state.inFlight = false;
        pendingChanges.delete(key);
        console.error('Fast cart update error:', error);
        refreshDrawer();
      });
  }

  function handleQuantityClick(event, button) {
    var wrapper = button.closest('.quantity-wrapper-drawer');
    if (!wrapper) return;

    var quantityValue = wrapper.querySelector('.cart-drawer__quantity-value');
    var key = wrapper.dataset.key;
    if (!quantityValue || !key) return;

    var currentQuantity = getNumber(wrapper.dataset.quantity, getNumber(quantityValue.textContent, 1));
    var nextQuantity = currentQuantity;
    var isMinus = button.classList.contains('cart-drawer__quantity-btn-minus');

    if (isMinus) {
      if (currentQuantity <= 1) return;
      nextQuantity = currentQuantity - 1;
    } else {
      var inventoryQuantity = getNumber(wrapper.dataset.inventory, 0);
      var trackQuantity = wrapper.dataset.trackQuantity === 'true';
      var allowOversell = wrapper.dataset.allowOversell === 'true';

      if (trackQuantity && !allowOversell && currentQuantity >= inventoryQuantity) return;
      nextQuantity = currentQuantity + 1;
    }

    quantityValue.textContent = nextQuantity;
    wrapper.dataset.quantity = String(nextQuantity);
    updateButtonStates(wrapper, nextQuantity);

    var countElement = document.getElementById('CartCount');
    if (countElement) {
      var currentCount = getNumber(countElement.textContent, 0);
      updateCartCount(Math.max(0, currentCount + (isMinus ? -1 : 1)));
    }

    scheduleChange(key, nextQuantity);
  }

  function handleRemoveClick(button) {
    var key = button.dataset.key;
    var cartItem = button.closest('.cart-drawer-item');
    if (!key) return;

    if (cartItem) {
      cartItem.style.transition = 'opacity 120ms ease, transform 120ms ease';
      cartItem.style.opacity = '0';
      cartItem.style.transform = 'translateX(8px)';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to remove cart item');
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshDrawer(cart.item_count);
      })
      .catch(function (error) {
        console.error('Fast cart remove error:', error);
        refreshDrawer();
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var quantityButton = event.target.closest(
        '.cart-drawer__quantity-btn-minus, .cart-drawer__quantity-btn-plus'
      );

      if (quantityButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        handleQuantityClick(event, quantityButton);
        return;
      }

      var removeButton = event.target.closest('.cart-drawer-item__remove-link');
      if (removeButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        handleRemoveClick(removeButton);
      }
    },
    true
  );
})();
